import { ReactNode } from "react";
import HelperText from "@ingka/helper-text";

type FixaHelperTextProps = {
  shouldValidate?: boolean;
  children?: ReactNode | undefined;
  className?: string;
  "data-testid"?: string;
};

function FixaHelperText(props: FixaHelperTextProps) {
  return <HelperText {...props} />;
}

export default FixaHelperText;
